var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLayout',{staticStyle:{"background":"var(--bg3)"},attrs:{"panels":_vm.panels,"padding":20,"gutter":20,"border-radius":"","env":{
    project:this.group
  }}},[_c('div',{staticStyle:{"position":"absolute","right":"0","width":"calc(25% + 12px)","background":"var(--bg2) linear-gradient(to right,var(--bg2),var(--bg3))","bottom":"0","top":"0","background-size":"cover","border-left":"3px solid var(--border)"},style:(this.windowWidth < 1400?'width:calc(40% + 3px)':'')})])
}
var staticRenderFns = []

export { render, staticRenderFns }